import React from "react";
// import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
// import { Editor } from 'react-draft-wysiwyg';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import draftToHtml from 'draftjs-to-html';
// import htmlToDraft from 'html-to-draftjs';

// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// import {ClassicEditor} from '@ckeditor/ckeditor5-editor-classic';
import MyUploadAdapter from '../MyUploadAdapter'



function MyUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = function (loader) {
        return new MyUploadAdapter(loader)
    };
}



const editorConfiguration = {

    extraPlugins: [MyUploadAdapterPlugin],
    mediaEmbed: {
        previewsInData: true
    },
  
};


class Header extends React.Component {

    state = {
        categories: [],
        tags: [],
        reviewers: [],
        editorState: ""//EditorState.createWithContent(initialEditorContent)
    }

    componentWillMount() {
        // console.log(this.props.data)
        if (this.props.data && this.props.data != '') {
            // const blocksFromHTML = convertFromHTML(this.props.data);
            // const initialEditorContent = ContentState.createFromBlockArray(
            //     blocksFromHTML.contentBlocks,
            //     blocksFromHTML.entityMap
            // );
            this.setState({ editorState: this.props.data })
        }
    }

    handleChangeSelect = (name, newVal) => {
        this.setState({
            [name]: newVal
        });
    }

   

    onEditorStateChange = editorState => {
        this.setState({ editorState })
        this.props.changeValue(this.props.header.key, editorState)
        // console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }

    render() {
        // console.log(CKEditor.config)
        return (
            <div className='mt-0 w-100'>
                {/* <label className={'mb-2 mr-1 ml-1 ' + (this.conditionalSettings('required', true) ? 'required' : '')} style={{ marginBottom: 3, fontSize: 12, marginTop: 5, color: '#999' }}>{this.props.label}</label> */}
                <div className="w-100" style={{ direction: 'ltr' }}>

                    <CKEditor
                        config={editorConfiguration}
                        editor={ClassicEditor}
                        data={this.state.editorState}
                        onReady={editor => {
                            // You can store the "editor" and use when it is needed.
                            console.log('Editor is ready to use!', editor);
                        }}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            this.onEditorStateChange(data)
                        }}
                        onBlur={(event, editor) => {
                            // console.log('Blur.', editor);
                        }}
                        onFocus={(event, editor) => {
                            // console.log('Focus.', editor);
                        }}
                    />


                   
                </div>
                {/* <input onChange={e=>{this.props.onChange(this.props.header.key,e.target.value)}} className='mediumiransansfont form-control' defaultValue={this.props.data} style={{backgroundColor:'#f7f7f7', color: '#3b3a40' }}/> */}
            </div>
        );
    }
}

export default Header;
